"use strict"; 
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Plugins
import i18n from "./i18n";
import axios from "./plugins/axios";
import vuetify from "./plugins/vuetify";
import moment from "moment";
import VueAnalytics from 'vue-analytics';



import he from 'he';

require('./components/global');
moment.locale("de");

// Prototypes
Vue.prototype.$he = he;
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();
window.flash = function (message) {
  Vue.prototype.$bus.$emit("flash", message);
}

Vue.prototype.$connection = Vue.config.devtools
  ? "https://localhost:3000"
  : "https://www.tgschwalbach.de";

// Uses

// use beforeEach route guard to set the language
router.beforeEach(function (to, from, next)  {
  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = "de";
  }

  // set the current language for i18n.
  i18n.locale = language;
  next();
});

Vue.use(VueAnalytics, {
  id: 'UA-191820430-1',
  router,
  autoTracking: {
    screenview: true
  }
});

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
